module.exports = __webpack_public_path__ + "9ff0303316066b0bf5a37e870b400935.png";